import { useTranslation } from 'react-i18next'

import { useTheme } from 'styled-components'

import { ComboBox } from '@reveni-io/reveni-ui'

import { options } from './constants'
import * as Styles from './styles'

const SettingsSelector = ({ value, onChange, disabled }) => {
  const theme = useTheme()
  const { t } = useTranslation()

  const getOptions = () => {
    return (
      options.map(option => ({
        label: (
          <Styles.OptionContainer>
            <Styles.TypeContainer>{option.icon}</Styles.TypeContainer> {t(option.label)}
          </Styles.OptionContainer>
        ),
        value: option.value,
      })) || []
    )
  }

  return (
    <ComboBox
      label={t('Configuración')}
      value={value}
      handleChange={e => onChange(e.target.value)}
      menuItems={getOptions()}
      backgroundColor={theme.colors.background.primary}
      fullWidth
      disabled={disabled}
    />
  )
}

export default SettingsSelector
